import { useUser } from '@clerk/clerk-react';

/**
 * Hook to detect user role from Clerk metadata
 *
 * @returns {object} Role information
 * @returns {boolean} isAdmin - True if user has admin role
 * @returns {boolean} isLoaded - True if Clerk user data is loaded
 * @returns {string|undefined} role - The user's role string
 *
 * @example
 * const { isAdmin, isLoaded } = useUserRole();
 *
 * if (!isLoaded) return <Loading />;
 * if (isAdmin) return <AdminPanel />;
 */
export function useUserRole() {
  const { user, isLoaded } = useUser();

  const isAdmin = user?.publicMetadata?.role === 'admin';

  return {
    isAdmin,
    isLoaded,
    role: user?.publicMetadata?.role as string | undefined
  };
}
